import type { IconButtonProps } from '@mui/material';
import { InfoIcon } from '@src/shared/ui/icons';
import { forwardRef } from 'react';
import IconButton from './IconButton';

const LegendIconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (props, ref) => {
    return (
      <IconButton ref={ref} {...props}>
        <InfoIcon />
      </IconButton>
    );
  },
);

LegendIconButton.displayName = 'LegendIconButton';
export default LegendIconButton;
